import { AnimatePresence, motion } from "framer-motion";
import AdminHeader from "../../component/AdminHeader";
import { useState } from "react";
import { ImagePlus, Layers, X } from "lucide-react";
import { FormInput, FormSelect, FormTextArea } from "../../helpers/AdminHelper";
import { useEffect } from "react";
import { http } from "../../axios/axios";
import { Edit, Trash2 } from "lucide-react";
import { GetImageUrl } from "../../helpers/GetImageUrl";
import StatCard from "../../component/StatCard";
import ActionButtons from "../../component/AdminActionButtons";

function CreateCategory({
  closeModal,
  handleSubmit,
  preview,
  setPreview,
  categoriesDetails,
  setCategoriesDetails,
}) {
  const inputClass =
    "w-full border border-white/10 bg-white/5 text-white px-4 py-3 rounded-xl mt-2 outline-none focus:border-blue-500 transition";

  const handleChange = (key, value) => {
    setCategoriesDetails((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (preview) {
      URL.revokeObjectURL(preview);
    }

    const url = URL.createObjectURL(file);

    setPreview(url);

    handleChange("categoryImage", file);
  };

  const removeLogo = () => {
    if (preview) {
      URL.revokeObjectURL(preview);
    }

    setPreview(null);

    handleChange("categoryImage", null);
  };

  return (
    <motion.div className="fixed inset-0 bg-black/90 backdrop-blur-xl z-50">
      <motion.div
        className="
        fixed z-50
        top-1/2 left-1/2
        -translate-x-1/2 -translate-y-1/2
        w-[95%]
        h-[90vh]
        bg-[#0a0f1a]
        border border-white/10
        rounded-2xl
        shadow-2xl
        overflow-hidden
        flex flex-col
        "
      >
        <div
          className="
          flex items-center justify-between
          px-8 py-5
          border-b border-white/10
          bg-white/[0.03]
          "
        >
          <div>
            <h3 className="text-xl font-black text-white uppercase">
              Create Category
            </h3>

            <p className="text-sm text-slate-400 mt-1">
              Add Category details and logo
            </p>
          </div>

          <button
            type="button"
            onClick={closeModal}
            className="
            h-10 w-10 rounded-xl
            bg-white/5 hover:bg-red-500
            text-slate-300 flex items-center justify-center
            "
          >
            <X size={20} />
          </button>
        </div>

        <form
          onSubmit={handleSubmit}
          className="
          p-8 space-y-5
          overflow-y-auto flex-1
          "
        >
          <div>
            <label className="text-sm text-slate-300">Category Logo</label>

            {preview ? (
              <div
                className="
                mt-2 relative h-36 rounded-xl
                border border-white/10
                bg-white/5
                flex items-center justify-center
                overflow-hidden
                "
              >
                <img
                  src={preview}
                  alt="category preview"
                  className="h-full w-full object-contain"
                />

                <button
                  type="button"
                  onClick={removeLogo}
                  className="
                  absolute top-2 right-2
                  h-8 w-8 rounded-full
                  bg-red-500 text-white
                  flex items-center justify-center
                  "
                >
                  <X size={16} />
                </button>
              </div>
            ) : (
              <label
                className="
                mt-2 h-36 rounded-xl
                border border-dashed border-white/20
                bg-white/5
                flex flex-col items-center
                justify-center cursor-pointer
                hover:bg-white/10 transition
                "
              >
                <ImagePlus size={30} className="text-slate-400" />

                <span className="text-sm text-slate-400 mt-2">Upload logo</span>

                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleLogoChange}
                />
              </label>
            )}
          </div>
          <div>
            <FormInput
              label={"Category Image Alt Text"}
              className={inputClass}
              placeholder={"e.g. CCTV camera product image"}
              value={categoriesDetails?.categoryImageAlt}
              onChange={(e) => handleChange("categoryImageAlt", e.target.value)}
            />
          </div>
          <div>
            <FormInput
              label={"Category Name"}
              className={inputClass}
              placeholder={"CCTV Cameras"}
              value={categoriesDetails?.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </div>

          <div>
            <FormInput
              label={"Slug"}
              className={inputClass}
              placeholder={"cctv-cameras"}
              value={categoriesDetails?.slug}
              onChange={(e) => handleChange("slug", e.target.value)}
            />
          </div>

          <div>
            <FormTextArea
              label={"Description"}
              rows={4}
              placeholder="Write a brief 2–3 line description about the category for display on the frontend."
              value={categoriesDetails?.description}
              onChange={(e) => handleChange("description", e.target.value)}
            />
          </div>
          <div>
            <FormInput
              label={"Meta Title"}
              className={inputClass}
              placeholder={"Best CCTV Cameras"}
              value={categoriesDetails?.metaTitle}
              onChange={(e) => handleChange("metaTitle", e.target.value)}
            />
          </div>
          <div>
            <FormTextArea
              label={"Meta Description"}
              rows={4}
              placeholder={"Buy latest CCTV cameras online"}
              value={categoriesDetails?.metaDescription}
              onChange={(e) => handleChange("metaDescription", e.target.value)}
            />
          </div>
          <div>
            <FormInput
              label={"Meta Tags"}
              className={inputClass}
              placeholder={"cctv, camera, surveillance"}
              value={categoriesDetails?.metaTags}
              onChange={(e) => handleChange("metaTags", e.target.value)}
            />
          </div>
          <div>
            <FormTextArea
              label={"Schema Script (JSON-LD)"}
              rows={8}
              placeholder={`{
  "@context": "https://schema.org",
  "@type": "Category",
  "name": "CCTV Cameras"
}`}
              value={categoriesDetails?.schemaScript || ""}
              onChange={(e) => handleChange("schemaScript", e.target.value)}
            />

            <p className="text-xs text-slate-400 mt-2">
              Add valid JSON-LD schema only
            </p>
          </div>
          <div
            className="
    flex justify-end gap-3
    pt-5
    border-t border-white/10
  "
          >
            <button
              type="button"
              onClick={closeModal}
              className="
      px-6 py-3
      rounded-xl
      bg-white/5
      hover:bg-white/10
      "
            >
              Cancel
            </button>

            <button
              type="submit"
              className="
      px-6 py-3
      rounded-xl
      bg-blue-600
      hover:bg-blue-700
      text-white
      "
            >
              Create Category
            </button>
          </div>
        </form>
      </motion.div>
    </motion.div>
  );
}

const AdminCategory = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoriesDetails, setCategoriesDetails] = useState({
    name: "",
    slug: "",
    description: "",
    categoryImage: null,
    categoryImageAlt: "",
    metaTitle: "",
    metaDescription: "",
    metaTags: "",
    schemaScript: "",
  });
  const [preview, setPreview] = useState(null);
  const [totalCategoryCount, setTotalCategoryCount] = useState(null);
  const [categories, setCategories] = useState([]);
  const [editId, setEditId] = useState(null);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    limit: 20,
  });
  const resetForm = () => {
    setCategoriesDetails({
      name: "",
      slug: "",
      description: "",
      categoryImage: null,
      categoryImageAlt: "",
      metaTitle: "",
      metaDescription: "",
      metaTags: "",
      schemaScript: "",
    });

    setPreview(null);
  };

  const closeModal = () => {
    resetForm();
    setIsModalOpen(false);
  };

  const isValidSlug = (slug) => {
    const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
    return slugRegex.test(slug);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!categoriesDetails.name?.trim()) {
      alert("Category name is required");
      return;
    }

    if (!categoriesDetails.slug?.trim()) {
      alert("Slug is required");
      return;
    }

    if (!isValidSlug(categoriesDetails.slug)) {
      alert("Invalid slug format");
      return;
    }

    if (!categoriesDetails.description) {
      alert("Description is required");
      return;
    }

    if (!editId && !categoriesDetails.categoryImage) {
      alert("Category image is required");
      return;
    }
    if (!categoriesDetails.categoryImageAlt?.trim()) {
      alert("Category Image Alt is required");
      return;
    }

    if (!categoriesDetails.metaTitle?.trim()) {
      alert("Meta Title is required");
      return;
    }

    if (!categoriesDetails.metaDescription) {
      alert("Meta Description is required");
      return;
    }

    if (!categoriesDetails.metaTags?.trim()) {
      alert("Meta Tags is required");
      return;
    }

    const formData = new FormData();

    formData.append("name", categoriesDetails.name);
    formData.append("slug", categoriesDetails.slug);
    formData.append("description", categoriesDetails.description);

    if (categoriesDetails.categoryImage) {
      formData.append("categoryImage", categoriesDetails.categoryImage);
    }

    formData.append("metaTitle", categoriesDetails.metaTitle);
    formData.append("metaDescription", categoriesDetails.metaDescription);
    formData.append("categoryImageAlt", categoriesDetails.categoryImageAlt);

    if (categoriesDetails.metaTags) {
      const keywordArray = categoriesDetails.metaTags
        .split(",")
        .map((k) => k.trim())
        .filter(Boolean);

      formData.append("metaTags", JSON.stringify(keywordArray));
    }

    let schemaData = "";

    if (categoriesDetails.schemaScript?.trim()) {
      try {
        JSON.parse(categoriesDetails.schemaScript);

        schemaData = categoriesDetails.schemaScript;
      } catch {
        alert("Invalid Schema JSON");
        return;
      }
    }

    formData.append("schemaScript", schemaData);

    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }
    try {
      let res;
      if (editId) {
        await http.put(`/category/update/${editId}`, formData);
      } else {
        await http.post("/category", formData);
      }
      await fetchCategories(pagination.page);
      closeModal();
      setEditId(null);
    } catch (error) {
      console.log(error.response?.data || error.message);
    }
  };

  const fetchCategories = async () => {
  try {
    const res = await http.get("/category", {
      params: {
        page: pagination.page,
        limit: pagination.limit,
      },
    });

    // console.log(
    //   "CATEGORIES FROM SERVER:",
    //   res.data.category
    // );

    setCategories(res.data.category);
    setTotalCategoryCount(res.data.total);

    setPagination((prev) => ({
      ...prev,
      page: res.data.page,
      totalPages: res.data.totalPages,
    }));
  } catch (error) {
    console.log(error.response?.data || error.message);
  }
};

  
  const handleMenuOrderChange = async (categoryId, menuOrder) => {
  try {
    // console.log("SENDING:", {
    //   categoryId,
    //   menuOrder: Number(menuOrder),
    // });

    const res = await http.patch("/category/menu-order", {
      categoryId,
      menuOrder: Number(menuOrder),
    });

    // console.log("PATCH RESPONSE:", res.data);

    await fetchCategories();

  } catch (error) {
    console.error(
      "POSITION ERROR:",
      error.response?.data || error.message
    );
  }
};

  useEffect(() => {
    fetchCategories(pagination.page);
  }, [pagination.page]);

  return (
    <div className="p-4 md:p-8 min-h-screen text-slate-200 ">
      <AdminHeader
        title="Product Categories"
        buttonText="Add Category"
        onClick={() => {
          setIsModalOpen(true);
        }}
      />
      <div className="mb-8  gap-4">
        <StatCard
          title="Total Categories"
          count={totalCategoryCount}
          icon={Layers}
        />
      </div>
      {categories.length === 0 ? (
        <div className="p-8 rounded-2xl bg-white/5 border border-white/10 text-center text-slate-400">
          No categories found
        </div>
      ) : (
        <div className="space-y-4">
          {categories.map((item) => (
            <div
              key={item._id}
              className="
      flex
      flex-col sm:flex-row
      sm:items-center
      sm:justify-between
      gap-4
      p-2
      rounded
        bg-slate-900/40
        border border-slate-800
        hover:border-slate-700
        hover:bg-slate-900/60
      transition
    "
            >
              {/* Left Content */}
              <div className="flex items-center gap-3 sm:gap-4">
                <div
                  className="
          h-12 w-12
          sm:h-16 sm:w-16
          rounded
          bg-white
          p-2
          flex
          items-center
          justify-center
          shrink-0
        "
                >
                  <img
                    src={GetImageUrl(item.categoryImage)}
                    className="
            max-h-full
            max-w-full
            object-contain
          "
                  />
                </div>

                <div>
                  <h3
                    className="
            text-white
            font-bold
            text-sm lg:text-base
          "
                  >
                    {item.name}
                  </h3>
                </div>
              </div>

              {/* Actions */}
              {/* <ActionButtons
                onEdit={() => {
                  setEditId(item._id);

                  setCategoriesDetails({
                    name: item.name,
                    slug: item.slug,
                    description: item.description,

                    metaTitle: item.metaTitle,

                    metaDescription: item.metaDescription,

                    metaTags: Array.isArray(item.metaTags)
                      ? item.metaTags.join(", ")
                      : item.metaTags || "",

                    schemaScript: item.schemaScript || "",

                    categoryImageAlt: item.categoryImageAlt || "",

                    categoryImage: null,
                  });

                  setPreview(GetImageUrl(item.categoryImage));

                  setIsModalOpen(true);
                }}
                onDelete={async () => {
                  if (!confirm("Delete this category?")) return;

                  await http.delete(`/category/delete/${item._id}`);

                  fetchCategories(pagination.page);
                }}
              /> */}

              {/* Position + Actions */}
              <div className="flex items-center gap-3">
                <select
                  value={item.menuOrder || ""}
                  onChange={(e) =>
                    handleMenuOrderChange(item._id, e.target.value)
                  }
                  className="
      bg-slate-800
      border border-slate-700
      text-white
      text-sm
      rounded-lg
      px-3 py-2
      outline-none
      focus:border-blue-500
    "
                >
                  <option value="">Position</option>

                  {Array.from(
                    { length: totalCategoryCount || 0 },
                    (_, index) => (
                      <option key={index + 1} value={index + 1}>
                        Position {index + 1}
                      </option>
                    ),
                  )}
                </select>

                <ActionButtons
                  onEdit={() => {
                    setEditId(item._id);

                    setCategoriesDetails({
                      name: item.name,
                      slug: item.slug,
                      description: item.description,

                      metaTitle: item.metaTitle,

                      metaDescription: item.metaDescription,

                      metaTags: Array.isArray(item.metaTags)
                        ? item.metaTags.join(", ")
                        : item.metaTags || "",

                      schemaScript: item.schemaScript || "",

                      categoryImageAlt: item.categoryImageAlt || "",

                      categoryImage: null,
                    });

                    setPreview(GetImageUrl(item.categoryImage));

                    setIsModalOpen(true);
                  }}
                  onDelete={async () => {
                    if (!confirm("Delete this category?")) return;

                    await http.delete(`/category/delete/${item._id}`);

                    fetchCategories(pagination.page);
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
      {categories.length > 0 && (
        <div
          className="
      flex
      flex-col sm:flex-row
      justify-center
      items-center
      gap-3 sm:gap-4
      mt-8
      px-2
    "
        >
          <button
            disabled={pagination.page === 1}
            onClick={() =>
              setPagination((p) => ({
                ...p,
                page: p.page - 1,
              }))
            }
            className="
        w-full sm:w-auto
        px-4 sm:px-5
        py-2
        rounded-xl
        bg-white/10
        hover:bg-white/20
        disabled:opacity-40
        transition
        text-sm sm:text-base
      "
          >
            Previous
          </button>

          <span
            className="
        text-white
        text-sm sm:text-base
        whitespace-nowrap
      "
          >
            Page {pagination.page} of {pagination.totalPages}
          </span>

          <button
            disabled={
              !pagination.totalPages ||
              pagination.page === pagination.totalPages
            }
            onClick={() =>
              setPagination((p) => ({
                ...p,
                page: p.page + 1,
              }))
            }
            className="
        w-full sm:w-auto
        px-4 sm:px-5
        py-2
        rounded-xl
        bg-blue-600
        hover:bg-blue-700
        disabled:opacity-40
        transition
        text-sm sm:text-base
      "
          >
            Next
          </button>
        </div>
      )}
      <AnimatePresence>
        {isModalOpen && (
          <CreateCategory
            handleSubmit={handleSubmit}
            closeModal={closeModal}
            setCategoriesDetails={setCategoriesDetails}
            categoriesDetails={categoriesDetails}
            preview={preview}
            setPreview={setPreview}
          />
        )}
      </AnimatePresence>
    </div>
  );
};
export default AdminCategory;
